module.exports = __webpack_public_path__ + "img/img (6).c00a6734.png";